<template>
  <div class="relative flex-center-between bg-transparent max-w-[343px]">
    <div class="flex-y-center px-3 py-5">
      <img class="w-6 h-6" :src="images[type]" alt="icon" />
      <div class="ml-2">
        <p class="text-white font-medium text-xs leading-130">
          {{ title }}
        </p>
      </div>
    </div>
    <i class="icon-close text-xl pr-3 cursor-pointer"></i>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

interface Props {
  type: "success" | "error" | "warning" | "info";
  title: string;
}

defineProps<Props>();
const images = computed(() => {
  return {
    success: "/images/svg/toast/success.svg",
    error: "/images/svg/toast/error.svg",
    warning: "/images/svg/toast/warning.svg",
    info: "/images/svg/toast/info.svg",
  };
});
</script>
<style>
.toast {
  box-shadow: 0 8px 20px rgba(18, 28, 37, 0.16);
}
</style>
